import React from 'react'

import { SingleFileInputProps } from '../types'

import { DragAndDropArea } from './DragAndDropArea'
import { UploadedFileItem } from './UploadedFileItem'

interface Props extends SingleFileInputProps {
  id: string
}

export const SingleFileInputContent = ({ onRemoveClick, ...props }: Props) => {
  if (!props.fileName) {
    return <DragAndDropArea {...props} />
  }

  return (
    <UploadedFileItem
      {...{
        fileName: props.fileName,
        uploadProgress: props.uploadProgress,
        thumbnail: props.thumbnail,
        url: props.url,
        onRemoveClick,
      }}
    />
  )
}
